import { encode } from 'gpt-tokenizer'
import { MAX_TOKEN_LIMIT } from './constant'

export function checkIsOverMaxTokenLimit(question: string) {
  const encodedLength = encode(question).length
  return encodedLength > MAX_TOKEN_LIMIT
}
